class SectionVideoStatistics implements ng.IComponentController {
    ltTitle: string;
    statistics: anm.VideoStatisticsItem[];
}

angular.module('animatronApp.sectionVideoStatistics', []).component('sectionVideoStatistics', {
    bindings: {
        ltTitle: '<',
        statistics: '<'
    },
    controller: SectionVideoStatistics,
    templateUrl: require('landing-template/components/sections/section-video-statistics.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/landing-template/components/sections/SectionVideoStatistics.ts